import { EMPTY_CUSTOMER_ENQUIRY_SEARCH_CRITERIA } from "presentation/constant/CustomerEnquiry/CustomerEnquirySearchCriteria";
import { useCustomerEnquiryVM } from "presentation/hook/CustomerEnquiry/useCustomerEnquiryVM";
import { useCustomerEnquiryTracked } from "presentation/store/CustomerEnquiry/CustomerEnquiryProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import CustomerEnquiryTitleBar from "./CustomerEnquiryTitleBar";
import CustomerEnquirySearchPanel from "./LeftPanel/CustomerEnquirySearchPanel";
import CustomerEnquiryTablePanel from "./Table/CustomerEnquiryTablePanel";

const CustomerEnquiryMaintenance: React.FC = () => {
    const [custoemrEnquiryState] = useCustomerEnquiryTracked();
    const [isLoading, setIsLoading] = useState(true);
    const customerEnquiryVM = useCustomerEnquiryVM();
    const { isShowSearchPanel, isAllowAutoSearch } = custoemrEnquiryState;

    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                await Promise.all([
                    customerEnquiryVM.loadDropdownOption(),
                ]);

                if (isAllowAutoSearch) {
                    let newSearchCriteria = {
                        ...EMPTY_CUSTOMER_ENQUIRY_SEARCH_CRITERIA,
                        customerTypeList: ['SL'],
                    };
                    await customerEnquiryVM.onSearch(newSearchCriteria);
                }
            } catch (error) {
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        };

        if (isAllowAutoSearch) {
            initialScreen();
        }

    }, [isAllowAutoSearch, customerEnquiryVM]);

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>
            <CustomerEnquiryTitleBar />
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowSearchPanel ? "20%" : "0%"}
                rightSectionWidth={isShowSearchPanel ? "80%" : "100%"}
                leftChildren={<CustomerEnquirySearchPanel />}
                rightChildren={<CustomerEnquiryTablePanel />}
            />
        </div>
    </>
}

export default memo(CustomerEnquiryMaintenance);